import React from "react";
import { useSelector } from "react-redux";
import { selectBaseUrl } from "../redux/slices/p2pSettingsSlice";
import { selectAllFormSettings } from "../redux/slices/formSettingsSlice";
import { replaceRegistrationState } from "../redux/slices/registrationSlice";
import { replaceRegistrationAccountState } from "../redux/slices/registrationAccountSlice";
import { replaceTeamsState } from "../redux/slices/teamsSlice";
import { replaceExistingRegistrations } from "../redux/slices/existingRegistrationsSlice";
import { replaceParentRegistration } from "../redux/slices/parentRegistrationSlice";
import { replaceRaceConditions } from "../redux/slices/raceConditionsSlice";
import { setPaymentPageValues } from "../redux/slices/formDataSlice";
import UpdateEventDataFromSessionStorage from "./UpdateEventDataFromSessionStorage";

const ConnectedUpdateEventDataFromSessionStorage = () => {
    const baseUrl = useSelector(selectBaseUrl);
    const formSettings = useSelector(selectAllFormSettings);
    const { template, id } = formSettings;

    const updateEventProps = {
        baseUrl,
        id,
        template,
        replaceRegistrationState,
        replaceRegistrationAccountState,
        replaceTeamsState,
        replaceExistingRegistrations,
        replaceParentRegistration,
        replaceRaceConditions,
        setPaymentPageValues,
    };

    return <UpdateEventDataFromSessionStorage {...updateEventProps} />;
};

export default ConnectedUpdateEventDataFromSessionStorage;
